import { RootState } from "./types";

export default {
    reload(state: RootState) {
        state.reload++;
    }
};
